import { FormattedMessage } from 'react-intl'

import { Button } from '@gto/ui/button'
import { ButtonGroup } from '@gto/ui/button-group'

import type { RedemptionOption } from '@/api/gen'
import type { SubscriptionLevelEnum } from '@/pages/rewards/constants'

export type SubscriptionLevelMobileSwitcherProps = {
  levels: RedemptionOption[]
  activeLevel: SubscriptionLevelEnum
  onClick: (level: SubscriptionLevelEnum) => void
}

export const SubscriptionLevelMobileSwitcher = ({
  levels,
  activeLevel,
  onClick,
}: SubscriptionLevelMobileSwitcherProps) => {
  return (
    <div className="flex justify-center">
      <ButtonGroup>
        {levels.map((plan) => (
          <Button
            key={plan.id}
            // oxlint-disable-next-line typescript/no-unsafe-enum-comparison
            variant={activeLevel === plan.subscription_level ? 'contained' : 'outlined'}
            onClick={() => {
              onClick(plan.subscription_level)
            }}
          >
            <FormattedMessage id={`edge.plansSection.level.${plan.subscription_level}.title`} />
          </Button>
        ))}
      </ButtonGroup>
    </div>
  )
}
